import React from 'react';
import { Keyword } from './partials/Keyword';
import { KeywordsListContainer } from './partials/KeywordsListContainer';

type KeywordsList = {
  keywords: Keyword[];
};

export function KeywordsList({ keywords }: KeywordsList) {
  if (!keywords || keywords?.length === 0) {
    return null;
  }

  return (
    <KeywordsListContainer>
      {keywords.map(keyword => (
        <Keyword key={keyword.name} keyword={keyword} />
      ))}
    </KeywordsListContainer>
  );
}
